export default {
  common: {
    submit: 'Submit',
    close: 'Close',
    filter: 'Filter',
    search: 'Search',
    reset: 'Reset',
    increase: 'Increase',
    selectOption: 'Please select an option',
    loading: 'Loading',
    active: 'Active',
    inactive: 'Inactive',
    fetchingData: 'Fetching data',
    more: 'More',
    actions: 'Actions',
    support: 'Support',
    dashboard: 'Dashboard',
    helpCenter: 'Help Center',
  },
  sbActionList: {
    emptyActions: 'No actions available.',
  },
  sbCloseButton: {
    escapeAbbreviation: 'ESC',
  },
  sbClipboard: {
    successMessage: 'Copied to clipboard!',
    errorMessage: 'Unable to copy to clipboard.',
  },
  sbDrawer: {
    closePanelAltText: 'Close panel',
  },
  sbDropdown: {
    noOptions: 'No options available.',
    noResults: 'No results found.',
    selectOneOrMore: 'Select one or more values',
  },
  sbFileUpload: {
    chooseFile: 'Choose File...',
  },
  sbFilter: {
    chooseOne: 'Choose One...',
    filterTooltip: 'Filters',
    columnsTooltip: 'Customize Columns',
    showAllWhere: 'Show all where:',
    addFilter: 'Add filter',
    collapseRow: 'Collapse row',
    showMore: '+{showMoreQty} More',
    showLess: 'Show Less',
    customFilter: 'This is a custom filter',
    customWrapper: [
      'This is a dummy wrapper component for tests and stories',
      'That replaces the CollapsableFilter component',
    ],
    filterValue: 'Filter value:',
  },
  sbFilterBar: {
    columnOptions: {
      resetColumns: 'Reset Columns',
      updateColumns: 'Update Columns',
      header: 'Customize Columns',
    },
    filterOptions: {
      resetFilters: 'Reset All Filters',
      updateFilters: 'Apply Filters',
      header: 'Filters',
      close: 'Close',
    },
  },
  sbTable: {
    expandRow: 'Expand Row',
    expandAllRows: 'Expand All Rows',
    collapseRow: 'Collapse row',
    collapseAllRows: 'Collapse All Rows',
    noRows: 'No rows',
    shipbobTable: 'A ShipBob Table',
    pageSize: 'Page Size',
    previous: 'Prev',
    next: 'Next',
    showTotalRecords: '{ firstIndex }-{ lastIndex } of { totalRecords }',
    showTotalRecordsLegacy: 'Showing { pageSize } of { totalRecords }',
  },
  sbErrorPages: {
    title: 'Oops, this is not the Bob you’re looking for!',
    sbFourOhFour: {
      subTitle: 'We can’t seem to track the page you’re looking for!',
      helpfulLinks: 'Here are some helpful links instead',
    },
    sbFiveHundred: {
      subTitle: 'There seems to be a problem on our end and we’re working on resolving it as soon as possible.',
      helpText: 'Have you tried reloading the page? If the problem persists, please contact',
    },
  },
  sbDatePicker: {
    langCode: 'en',
  },
  sbDraggableFileUpload: {
    dragText: 'Drag a file here, or',
    browse: 'click here to browse',
    emptyImageAlt: 'File Empty Image',
    loadedImageAlt: 'File Loaded Image',
    conjuntion: 'and',
    anyFile: 'Any',
    conditions1: 'Only ',
    conditions2: ' files are allowed',
    conditions3: ', and no more than ',
    conditions4: ' in size.',
  },
  sbPagination: {
    pagination: 'Page {currentPage} of { totalPages }, Showing { visibleRecordsInterval } of { totalRecords }, ',
    gotoPage: 'Go to page: ',
  },
};
